let stampaInCorso = false;

const preparaIframe = () => {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.setAttribute("title", "Stampa");
  Object.assign(iframe.style, {
    position: "fixed",
    right: "0",
    bottom: "0",
    width: "1px",
    height: "1px",
    border: "0",
    opacity: "0",
    pointerEvents: "none",
  });
  return iframe;
};

const avviaStampa = (iframe, cleanupExtra) => {
  let avviata = false;
  let pulita = false;
  const cleanup = () => {
    if (pulita) return;
    pulita = true;
    if (iframe.isConnected) iframe.remove();
    cleanupExtra?.();
    stampaInCorso = false;
  };
  iframe.onload = () => {
    if (avviata) return;
    avviata = true;
    window.setTimeout(() => {
      try {
        const target = iframe.contentWindow;
        target.addEventListener?.("afterprint", cleanup, { once: true });
        target.focus();
        target.print();
        window.setTimeout(cleanup, 60000);
      } catch (error) {
        cleanup();
        console.error("Impossibile avviare la stampa", error);
      }
    }, 250);
  };
  document.body.appendChild(iframe);
};

export function printHtmlDirect(html, title = "Stampa") {
  if (stampaInCorso) return false;
  stampaInCorso = true;
  const iframe = preparaIframe();
  iframe.srcdoc = String(html).replace(
    /<head([^>]*)>/i,
    `<head$1><meta charset="utf-8"><title>${String(title).replace(/[<>&]/g, "")}</title>`,
  );
  avviaStampa(iframe);
  return true;
}

export function printPdfBlobDirect(blob) {
  if (stampaInCorso) return false;
  stampaInCorso = true;
  const objectUrl = URL.createObjectURL(blob instanceof Blob ? blob : new Blob([blob], { type: "application/pdf" }));
  const iframe = preparaIframe();
  iframe.src = objectUrl;
  avviaStampa(iframe, () => URL.revokeObjectURL(objectUrl));
  return true;
}
